import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import Header from '../components/nav/Header.js';
import Footer from '../components/nav/Footer.js';
import '../styles/thank-you.css';
import content from '../assets/content.json';

export default function ContactPageFreeThankYou() {
  const freeThankYouContent = content.contactPageFreeThankYou;

  useEffect(() => {
    const url = new URL(window.location);
    if (url.search) {
      window.history.replaceState({}, document.title, url.pathname);
    }
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{content.metadata.contactPageFreeThankYouMetadata.title}</title>
        <meta name="description" content={content.metadata.contactPageFreeThankYouMetadata.description} />
      </Helmet>
      <div>
        <Header />
        <div className="thank-you-page-container">
          <div className="thank-you-content-wrapper">
            <div className="thank-you-content">
              <div className="content-text">
                {freeThankYouContent.thankYouText?.heading && (
                  <h1 className="thank-you-header">{freeThankYouContent.thankYouText.heading}</h1>
                )}
                {freeThankYouContent.thankYouText?.paragraphs?.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              {freeThankYouContent.listSections?.map((section, sectionIndex) => (
                <div key={`list-${sectionIndex}`} className="list-section list-section-thank-you">
                  {section.sectionTitle && <h3 className="list-section-title">{section.sectionTitle}</h3>}
                  {section.listType === "bullet" && (
                    <ul>
                      {section.sectionItems?.map((item, i) => (
                        <li key={i} className="list-item">{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
              <div className="content-text">
                {freeThankYouContent.payOffText?.paragraphs?.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              {freeThankYouContent.subHeadTwo && (
                <h3 className="thank-you-subhead">{freeThankYouContent.subHeadTwo}</h3>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
